import { render } from "./ArrowExpandable.vue?vue&type=template&id=dc341300"
import script from "./ArrowExpandable.vue?vue&type=script&lang=js"
export * from "./ArrowExpandable.vue?vue&type=script&lang=js"

import "./ArrowExpandable.vue?vue&type=style&index=0&id=dc341300&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__